module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-order-source":"Delete Order Source","order-source-deleted":"Order source deleted","failed-delete-order":"Failed to delete order source"}}')
  delete Component.options._Ctor
}
